import axiosInstance from '../apiServices/axios';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { RACI_MATRIX } from '../apiServices/api_routes';
import { createEmptyRaciMatrix } from '../components/RaciMatrix/raciMatrixModel';

const projectRaciUrl = projectId => `${RACI_MATRIX}${projectId}/`;

export const GetRaciMatrix = createAsyncThunk('GET_RACI_MATRIX', async (projectId, { rejectWithValue }) => {
    try {
        const id = projectId || localStorage.getItem('project_id');
        const response = await axiosInstance.get(projectRaciUrl(id));
        return response.data;
    } catch (error) {
        return rejectWithValue(error.response?.data || error.message);
    }
});

export const PutRaciMatrix = createAsyncThunk(
    'PUT_RACI_MATRIX',
    async ({ projectId, matrix }, { rejectWithValue }) => {
        try {
            const id = projectId || localStorage.getItem('project_id');
            const payload = {
                version: matrix.version ?? 1,
                groups: matrix.groups,
                columns: matrix.columns,
                activities: matrix.activities,
                assignments: matrix.assignments,
            };
            const response = await axiosInstance.put(projectRaciUrl(id), payload);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    },
);

const initialState = {
    matrix: createEmptyRaciMatrix(),
    canEdit: false,
    updatedAt: null,
    status: 'idle',
    saveStatus: 'saved',
    error: null,
};

const raciMatrixSlice = createSlice({
    name: 'raciMatrix',
    initialState,
    reducers: {
        setRaciMatrixLocal: (state, action) => {
            state.matrix = action.payload;
        },
        setRaciSaveStatus: (state, action) => {
            state.saveStatus = action.payload;
        },
        resetRaciMatrixState: () => initialState,
    },
    extraReducers: builder => {
        builder
            .addCase(GetRaciMatrix.pending, state => {
                state.status = 'loading';
                state.error = null;
            })
            .addCase(GetRaciMatrix.fulfilled, (state, { payload }) => {
                state.status = 'succeeded';
                state.canEdit = payload?.can_edit !== false;
                state.updatedAt = payload?.updated_at ?? null;
                state.matrix = {
                    version: payload?.version ?? 1,
                    groups: payload?.groups ?? [],
                    columns: payload?.columns ?? [],
                    activities: payload?.activities ?? [],
                    assignments: payload?.assignments ?? {},
                };
                state.saveStatus = 'saved';
            })
            .addCase(GetRaciMatrix.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload || action.error?.message;
            })
            .addCase(PutRaciMatrix.pending, state => {
                state.saveStatus = 'saving';
            })
            .addCase(PutRaciMatrix.fulfilled, (state, { payload }) => {
                state.saveStatus = 'saved';
                state.canEdit = payload?.can_edit !== false;
                state.updatedAt = payload?.updated_at ?? null;
                state.matrix = {
                    version: payload?.version ?? 1,
                    groups: payload?.groups ?? [],
                    columns: payload?.columns ?? [],
                    activities: payload?.activities ?? [],
                    assignments: payload?.assignments ?? {},
                };
            })
            .addCase(PutRaciMatrix.rejected, (state, action) => {
                state.saveStatus = 'error';
                state.error = action.payload || action.error?.message;
            });
    },
});

export const { setRaciMatrixLocal, setRaciSaveStatus, resetRaciMatrixState } = raciMatrixSlice.actions;
export default raciMatrixSlice.reducer;
